import { createContext } from 'react';

// True only beneath the Descope AuthProvider, which _app mounts once a project id and a country
// resolve. Resident session hooks throw outside it, so callers that can run without it read this first.
export const ResidentAuthContext = createContext(false);
